import { canAssignOrderLineEmployees } from '@washday/utilities';
import { useSelector } from 'react-redux';

const useCanAssignOrderLineEmployees = (): boolean => {
  const { user } = useSelector((state: any) => state.user);
  return canAssignOrderLineEmployees(user?.permission);
};

export default useCanAssignOrderLineEmployees;
